import React from "react";

function App() {
  return (
    <div>
      <div style={{ margin: "1rem" }}>
        <h2 style={{ textDecoration: "underline", textAlign: "center" }}>
          PBC Privacy Policy
        </h2>
        <div
          style={{
            margin: "3rem 20rem 4rem 20rem",
          }}
        >
          <h2 style={{ textDecoration: "underline", textAlign: "center" }}>
            TERMS AND CONDITIONS
          </h2>
          <p style={{ fontSize: "1.5rem" }}>
            These Terms and Conditions govern the use of our digital platform.
            By using and accessing our digital platform, the user/member agrees
            and accepts these Terms and Conditions. Should you have questions or
            concerns, you may contact us via{" "}
            <span style={{ textDecoration: "underline" }}>
              09305229700 or 839-5384
            </span>
          </p>

          <h2>ACCESS</h2>
          <p style={{ fontSize: "1.5rem" }}>
            In gaining access to our digital platform, the user/member is
            responsible for maintaining the confidentiality of all details
            provided for in their registration, including their passwords. The
            user/member accepts full responsibility and liability for any
            activity under their account and shall take necessary steps to
            ensure that their password is kept confidential. If their account is
            compromised, the user/member must immediately inform us to prevent
            any unauthorized access to their account.
            <br /> <br /> We do not warrant that the use of our digital platform
            and/or access to any material downloaded to it will not cause loss
            or damage to any property, including but not limited to loss of
            data, computer virus infection and/or spyware. We shall not be
            liable for any loss of content or material uploaded or transmitted
            through our platform. To the extent permitted by law, we exclude any
            warranties, undertakings and/or representations that the content,
            materials, accuracy, availability or completeness of the information
            and content of our digital platform or any part thereof are
            available for use in any jurisdiction. <br /> <br />
            We are also not liable for the loss or damage for any changes made
            by unauthorized third parties. <br /> <br />
            We cannot always guarantee uninterrupted access to our digital
            platform. From time to time, we may suspend access to the digital
            platform for repair and/or maintenance.
          </p>

          <h2>NO ADVICE</h2>
          <p style={{ fontSize: "1.5rem" }}>
            This digital platform does not provide any personal and/or financial
            advice of any kind. The products and services provided do not take
            into consideration the user/member’s personal financial or insurance
            position. Hence, the user/member is advised to always obtain
            independent advice before purchasing or applying for any products or
            services provided in this digital platform.
          </p>

          <h2>THIRD PARTY TOOLS AND LINKS</h2>
          <p style={{ fontSize: "1.5rem" }}>
            The user/member may be linked to other third-party tools and links
            provided by third-party service providers. These tools and links are
            housed in third-party servers or sites which are independent from
            our servers. The user/member will leave our digital platform and
            servers once these third-party servers and sites are accessed.
            Therefore, access to such servers or sites are subject to their own
            terms and conditions and we shall not be held liable and/or
            responsible for the content and accuracy of such servers or sites.
            Concerns regarding any such third-party servers or sites should be
            directed to the service or resource.
          </p>

          <h2>PRODUCT PURCHASE</h2>
          <p style={{ fontSize: "1.5rem" }}>
            The use of our digital platform is only available to our members.
            The application and purchase of our products and services must be
            done within the Philippines. The applicant must be a Filipino
            citizen or a foreigner who is currently a legal resident of the
            Philippines, between the age of 18-70. The members may opt to cover
            themselves and/or their spouse, and children. <br /> <br />
            Any request to purchase a product or service represents the member’s
            offer which we may accept or reject depending on the terms and
            conditions of such product or service. The user/member must ensure
            that all the details and information provided are correct and that
            there are sufficient funds to cover the cost of the product or
            service purchased. <br /> <br />
            All requests or applications for a specific product or service shall
            comply with our approval criteria and are governed by the terms and
            conditions that apply to the specific product or service requested.
            Kindly refer to each product or service policy details for more
            information. <br /> <br />
            The terms and conditions and the precise cover period of the product
            or service purchased shall be indicated in the membership
            certificate that we shall issue to the user/member upon acceptance
            of their request or application. Likewise, the terms and conditions
            of a product or service purchased shall be covered by the terms and
            conditions specific to the product or service purchased.
            <br /> <br />
            We are not liable for the withdrawal of a product or service or for
            the rejection of the user/member’s application for a product or
            service that has not passed our approval criteria.
          </p>

          <h2>TRANSACTIONS</h2>
          <p style={{ fontSize: "1.5rem" }}>
            The user/member’s confirmation via electronic means or their
            confirmation of payment signifies the user/member’s acceptance of
            the terms and conditions of any product or service purchased. <br />{" "}
            <br />
            The user/member shall inform us immediately of any changes to their
            registered mobile number and/or other details needed for us to
            contact them. The user/member shall be responsible in ensuring that
            the mobile number or email address that they have provided shall
            remain active during the duration of their use of our digital
            platform. We shall not be held liable for any communications or
            emails sent to a user/member’s inactive mobile number or email
            account. <br /> <br />
            We shall not be liable for any failure to transmit any instruction
            or communication coming from the user/member due to electronic,
            telecommunication, system and/or software failure. To the extent
            permitted by law, we may refuse to process a transaction at any time
            and for any reason.
          </p>

          <h2>PURCHASING INSURANCE POLICIES</h2>
          <p style={{ fontSize: "1.5rem" }}>
            Users/members may purchase the following products or services
            through the digital platform:
            <br /> <br />
            <span style={{ fontSize: "1.5rem", marginLeft: "1rem" }}>
              <span style={{ textDecoration: "underline" }}>
                1. Basic Life Insurance Plan
              </span>{" "}
              <br /> <br />
              <div style={{ fontSize: "1.5rem", marginLeft: "2rem" }}>
                ★ Qualifications
                <br /> <br />
                → Applicant must be 18-65 years old <br />→ Must be a member of
                an organized group <br /> <br />★ Premium <br /> <br />
                → Membership Fee : Php 200.00 <br />→ Annual : Php 560.00 →
                Weekly : Php 12.00 <br /> <br />★ Benefits
                <br /> <br />
                → Natural Death Benefit <br />→ Accidental Death Benefit with
                Burial Expense Benefit <br />→ Accidental Disablement Benefit{" "}
                <br />→ Accidental Medical Reimbursement Benefit <br />
                <br />★ Requirements for membership <br />
                <br />→ Marriage Contract
                <br /> <br />
                → Certificate of no Marriage (CENOMAR from PSA) <br />→ Birth
                Certificate or any document which shows the date of birth such
                as:{" "}
                <div style={{ marginLeft: "2rem" }}>
                  ▪ Baptismal Certificate <br />▪ PhilHealth MDR <br />▪ Voters
                  Certification <br />▪ Joint Affidavit of Two Disinterested
                  Persons <br />▪ Legal Adoption for adopted children <br />
                </div>
                <br />
                <br />★ Termination of Coverage
                <br /> <br />→ Upon death or TPD due to accident of the member{" "}
                <br />→ Upon resignation from PBC-MBA <br />→ Upon expiration of
                the grace period → Upon withdrawal of the equity value on the
                life insurance benefit <br />→ If member is terminated with
                cause by PBC-MBA <br />→ Upon reaching the exit/termination age
                of 75 <br />
                <br />★ Take Note: Dependent’s coverage terminates upon the
                termination of the member’s coverage.
              </div>
            </span>
            <br />
            <br />
            <span style={{ fontSize: "1.5rem", marginLeft: "1rem" }}>
              <span style={{ textDecoration: "underline" }}>
                2. Credit Life Insurance Plan
              </span>{" "}
              <br />
              <br />
              <div style={{ fontSize: "1.5rem", marginLeft: "2rem" }}>
                ★ Credit Life Insurance Plan
                <br /> <br />
                → P0.80 per P1,000.00 per month
                <br />
                <br />★ Requirement
                <br />
                <br />→ Must be a member of PBC-MBA
                <br />
                <br />★ Benefits
                <br /> <br />→ Upon the death or Total and Permanent Disability
                (TPD) of the insured, PBC-MBA will pay the Loan amount insured.
                <br />
                <br />★ TERMINATION OF INDIVIDUAL COVERAGE
                <br />
                <br />→ The insurance coverage shall automatically terminate
                under the earliest of the following conditions: upon the death
                or TPD of the Insured DEBTOR upon the expiration of the term of
                the loan when the Insured DEBTOR reaches age seventy-five (75)
                upon full payment of the loan
              </div>
            </span>
            <br />
            <br />
            <span style={{ fontSize: "1.5rem", marginLeft: "1rem" }}>
              <span style={{ textDecoration: "underline" }}>
                3. Hospitalization Assistance Pamilya Insurance Plan
              </span>{" "}
              <br />
              <br />
              <div style={{ fontSize: "1.5rem", marginLeft: "2rem" }}>
                ★ Credit Life Insurance Plan
                <br />★ Weekly Php 10.00
                <br />
                <br />★ Maternity Benefit
                <br /> <br />→ Maximum of 5 days per contract year due to infant
                delivery, miscarriage, or pregnancy-related conditions requiring
                confinement.
                <br />
                <br />★ Sickness Benefit
                <br />
                <br />→ is a daily cash allowance paid to the member for the
                number of days a member or his/her legal dependent is unable to
                work due to bodily injury or sickness requiring hospitalization
                confinement but not related to pregnancy.
                <br /> <br /> • Member – maximum of 18 days per contract year{" "}
                <br />• Dependent – Maximum of 9 days per contract year
                <br />
                <br />★ TERMINATION OF INDIVIDUAL COVERAGE
                <div style={{ marginLeft: "1rem" }}>
                  <br />→ For Members <br />
                  <div style={{ marginLeft: "1rem" }}>
                    ➢ Upon termination of membership and coverage under the
                    Basic Life Insurance Plan; Upon expiration of the grace
                    period if no payment has been received by then; Upon
                    attainment of age seventy-five (75) of the member
                    <br />
                    <br />
                  </div>
                  → For Dependents <br />
                  <div style={{ marginLeft: "1rem" }}>
                    ➢ For the legal dependents, upon exceeding the age of
                    eligibility. <br />
                    <br />
                  </div>
                </div>
                <br />★ Dependent’s coverage terminates upon the termination of
                the member’s coverage.
              </div>
            </span>
            <br /> <br />
            Once we have assessed , processed, and accepted the application or
            request, we shall provide the approved member a membership
            certificate that includes the membership number and recognition
            date. Our new and existing members may access their membership
            certificate in their “plans” tab found in our digital platform. The
            user/member, through their request or application, makes an
            electronic offer via the digital platform and we shall
            electronically communicate our acceptance via the same platform.{" "}
            <br /> <br />
            We may process all completed applications without further consent
            from or reference to the user/member. We may also treat all
            electronic instructions transmitted from the user/member’s
            account/email as authentic and we shall be under no obligation to
            verify authenticity, authority and/or accuracy of such instructions.
          </p>

          <h2>PAYMENTS</h2>
          <p style={{ fontSize: "1.5rem" }}>
            Payments may be made via our digital platform or through the agent.
            To secure the user/member’s payment via our digital platform, we may
            use third-party providers to process the user/member’s payment. We
            shall not be held liable if the mode of payment used by the
            user/member shall be declined by the said third-party provider.{" "}
            <br /> <br />
            Once payment has been completed by the user/member, we shall
            immediately acknowledge receipt of the same. Should we need to
            verify such payment through our third-party providers, we will
            inform the user/member of the pending status of the said payment. In
            such case, the user/member may still cancel the payment and we shall
            reimburse the said payment in full. The payment shall be deemed as
            completed upon the user/member’s receipt of the notice that payment
            has been accepted/completed. <br /> <br />
            Payment history and summary of payments shall be available on our
            digital platform in the “Plans” tab.
          </p>

          <h2>ON CLAIMS</h2>
          <p style={{ fontSize: "1.5rem" }}>
            The user/member may apply for a claim through the “Claims” section
            under “Homepage” tab. They may also notify the MBA through the
            “Chat” function of the digital platform.
          </p>

          <h2>OWNERSHIP</h2>
          <p style={{ fontSize: "1.5rem" }}>
            This digital platform is owned by PBC-MBA. All policies available
            for purchase are underwritten by PBC-MBA, an insurance company
            licensed to the Insurance Commission. <br /> <br />
            We own all copyrights, design, graphics, and other intellectual
            property rights in our digital platform unless stated otherwise. All
            images, logos, names, and trademarks are proprietary marks of
            PBC-MBA. <br /> <br />
            Anyone gaining access to our digital platform may not modify,
            disassemble or otherwise create derivative works from any material
            found in our digital platform. We have the right to file the
            necessary legal action to protect our interests.
          </p>

          <h2>USE AND PROCESSING OF PERSONAL INFORMATION</h2>
          <p style={{ fontSize: "1.5rem" }}>
            By accessing our digital platform, the user/member consents to the
            processing of their personal information in accordance with our
            Security and Privacy Statement.
            <br /> <br />
            We are committed to protecting and respecting the user/member’s
            privacy in accordance with Republic Act 101731, its Implementing
            Rules and Regulations (IRR) and all other relevant laws and
            regulations. Our Security and Privacy Statement may be accessed on
            our website.
            <br /> <br />
            The following are the personal data that we may collect and/or
            process:
            <br /> <br />
            <div style={{ marginLeft: "1rem" }}>
              a. Name <br />
              b. Birthdate <br />
              c. Age <br />
              __________________________
              <br />
              <span style={{ fontSize: ".8rem" }}>
                ¹ Data Privacy Act of 2012
              </span>
              <br />
              d. Gender
              <br />
              e. Nationality
              <br />
              f. Contact Information such as home, office or mailing address,
              email
              <br />
              address, telephone number and mobile number
              <br />
              g. Specimen Signatures
              <br />
              h. Government ID details
              <br />
              i. Occupation
              <br />
              j. Financial Information
              <br />
              k. Health Information
              <br />
              l. Payment details
              <br />
              m. All other information provided to us through our digital
              platform
              <br />
            </div>{" "}
            <br /> <br />
            We may collect this information through you or your family members,
            through your authorized representative, through information
            generated from the use of our digital platform, third-party servers,
            cookies, location service and IP addresses, and other sources or
            organizations to assist in prevention and detection of crimes,
            police and law enforcement agencies. <br /> <br />
            The user/member’s personal information shall be used to process
            their transactions on our digital platform. It shall also be used in
            compliance with domestic and/or foreign laws and regulations, and
            policies and procedures without our company. The same shall also be
            used for any data analytics, profiling and research to be used
            mainly to improve customer experience and determine business
            strategies. Finally, the same shall be used to help us in risk
            management, identity verification, and/or fraud protection. <br />{" "}
            <br />
            The personal information shared by the user/member shall be shared
            within the company, financial/health partners, third-party servers
            and sites, and, if necessary, financial crime prevention agency, and
            other government bodies. <br /> <br />
            The user/member, as the owner of the personal information, shall be
            informed of the processing of their personal data. They may also
            object to the processing and sharing of their information. They may
            also request a copy of all the information that we have collected
            for the purpose of reviewing, modifying, or deletion when requested.
            As the owner of the personal information, the user/member may also
            suspend, withdraw or order the removal, destruction and blocking of
            their information in our system. They shall be indemnified for any
            damage sustained should there be an inaccurate, incomplete,
            outdated, false, unlawful or unauthorized collection and use of
            their information. <br /> <br />
            We shall take all reasonable steps to ensure that the user/member’s
            identity shall first be verified before any of the above actions
            shall be taken. <br /> <br />
            The information provided by the user/member shall be retained during
            the transaction and five years after the end of each user/member
            relationship. We shall retain the information should the law
            requires it for a longer period of retention. After the said period,
            all information shall be destroyed in accordance with the
            requirements of the law.
          </p>

          <h2>RESTRICTION OF USE</h2>
          <p style={{ fontSize: "1.5rem" }}>
            The digital platform may only be used for legitimate purposes, such
            as obtaining insurance quotes, information relating to our products
            and services, and access to products and services for purchase.
            Anyone obtaining access to our digital platform shall be responsible
            for all electronic communications and/or correspondence sent from
            their device.
            <br /> <br />
            We have the right to take the necessary legal action for obtaining
            access to our digital platform with the intent to damage, corrupt,
            interrupt or impair our services.
            <br /> <br />
            All communications and correspondences coming from the user/member’s
            account and registered email address shall be presumed as valid,
            genuine, and authentic statements from the user/member. The
            user/member cannot hold us liable for any loss, damage, or liability
            that may result from our action following the instructions contained
            in communications and correspondences sent via the user/member’s
            account and registered email address.
            <br /> <br />
            Anyone obtaining access to our digital platform agrees to these
            Terms and Conditions. S/he agrees to indemnify us for any liability
            incurred by us for any damage or expense suffered as a result or
            consequence of the breach of these Terms and Conditions.
          </p>

          <h2>AMENDMENTS</h2>
          <p style={{ fontSize: "1.5rem" }}>
            These Terms and Conditions may be updated and/or amended from time
            to time without need of notice. The user/member agrees that the
            posting of any updates or amendments in the digital platform shall
            be construed as notice of such changes. <br /> <br />
            Anyone obtaining access accepts these terms and conditions by
            proceeding to use and/or transact with our digital platform. <br />{" "}
            <br />
            If any of the terms and conditions found herein are deemed unlawful,
            void, or unenforceable, the particular provision shall be deemed
            deleted and will not affect the validity and enforceability of the
            rest of the provisions.
          </p>

          <h2>LAW AND JURISDICTION</h2>
          <p style={{ fontSize: "1.5rem" }}>
            The use of this digital platform shall be governed by and construed
            in accordance with the laws of the Philippines. All disputes shall
            be subject to the exclusive jurisdiction of the courts of
            Philippines only.
          </p>

          <h2>INDEMNITY AND WAIVER</h2>
          <p style={{ fontSize: "1.5rem" }}>
            Anyone obtaining access to our digital platform and our services
            agrees to indemnify us for any breach of these Terms and Conditions
            and we shall take the necessary legal action against any violator.
            <br /> <br />
            We, including all our officers, directors, and employees, shall not
            be held liable for any economic, data, and/or profit losses suffered
            or incurred arising out or in connection with the use or access of
            our digital platform.
          </p>

          <h2>ACKNOWLEDGMENT</h2>
          <p style={{ fontSize: "1.5rem" }}>
            By using and accessing our digital platform, the user/member
            acknowledges and accepts these Terms and Conditions. We have no
            obligation to specifically notify the user/members of any variation
            or amendment to these Terms and Conditions.
          </p>

          <h2 style={{ textAlign: "center" }}>DATA PRIVACY STATEMENT</h2>
          <p style={{ fontSize: "1.5rem" }}>
            We are committed to maintaining the accuracy, confidentiality, and
            security of your personal identifiable information ("Personal
            Information"). As part of this commitment, our privacy policy
            governs our actions as they relate to the collection, use, and
            disclosure of Personal Information.
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
